import { createSlice } from '@reduxjs/toolkit';
import { IDistanceAndDuration } from 'Shared/Types/distance';
import { ICoordinate } from 'Shared/Types/coordinate';
import {
  getCoordinateByLocation,
  getRouteDistanceAndDuration,
  getMilesOut,
} from './reducer';
import { RootState } from 'Redux/store';

interface ILocationState {
  currentCoordinate?: ICoordinate | null;
  currentDistanceAndDuration?: IDistanceAndDuration | null;
  currentMilesOut?: IDistanceAndDuration | null;
  error?: string | null;
  loading: boolean;
}

const initialState: ILocationState = {
  currentCoordinate: null,
  currentDistanceAndDuration: null,
  currentMilesOut: null,
  loading: false,
  error: null,
};

const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    resetCurrentDistanceAndDuration: (state) => {
      state.currentDistanceAndDuration = null;
    },
    resetCurrentMilesOut: (state) => {
      state.currentMilesOut = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCoordinateByLocation.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getCoordinateByLocation.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(getCoordinateByLocation.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      state.currentCoordinate = action.payload;
    });

    builder.addCase(getRouteDistanceAndDuration.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getRouteDistanceAndDuration.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
      state.currentDistanceAndDuration = undefined;
    });
    builder.addCase(getRouteDistanceAndDuration.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      state.currentDistanceAndDuration = action.payload;
    });

    builder.addCase(getMilesOut.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getMilesOut.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
      state.currentMilesOut = undefined;
    });
    builder.addCase(getMilesOut.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      state.currentMilesOut = action.payload;
    });
  },
});

export const { resetCurrentDistanceAndDuration, resetCurrentMilesOut } =
  locationSlice.actions;

export const selectLocationLoading = (state: RootState) =>
  state.location.loading;
export const selectLocationError = (state: RootState) => state.location.error;
export const selectCurrentCoordinate = (state: RootState) =>
  state.location.currentCoordinate;
export const selectMilesOut = (state: RootState) =>
  state.location.currentMilesOut;
export const selectDistanceAndDuration = (state: RootState) =>
  state.location.currentDistanceAndDuration;

export default locationSlice;
